import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const BNZProjectSubmissionFileDataSchema = yup.object().shape({
  approval: yup.string().nullable().optional(),
  projectName: yup.string().nullable().optional(),
  foremanName: yup.string().nullable().optional(),
  foremanRole: yup.string().nullable().optional(),
  foremanSignature: yup.string().nullable().optional(),
  notes: yup.string().nullable().optional(),
  recreatedAt: yup.string().nullable().optional(),
  submittedAt: yup.string().nullable().optional(),
  submittedBy: yup.string().nullable().optional(),
})

export type BNZProjectSubmissionFileData = yup.InferType<typeof BNZProjectSubmissionFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<BNZProjectSubmissionFileData>

export const BNZProjectSubmissionFileMappings: RequiredFileData = {
  approval: 'a730eedb-d653-48b8-ac5e-76d8040b7a18',
  projectName: '7a6de555-e605-4bda-9507-6e9e5c334648',
  foremanName: 'fd8a1c29-8ca3-412c-8330-17417e7558cc',
  foremanRole: '67482e4a-e418-4a9f-a29e-7f4f54380905',
  foremanSignature: 'ecc41125-f9ca-4b77-9336-967b6e85d0a5',
  notes: '0a1deb5a-4974-4f80-909d-11982a8480f8',
  recreatedAt: 'c4deb4e0-b039-4410-bc83-788c08427f7c',
  submittedAt: 'a3a2defe-1c07-4ae6-a7e6-f1ee2cbddefe',
  submittedBy: '6bf62c1d-b56f-468c-8c4f-fee480e3a223',
}
